module.exports = __webpack_public_path__ + "static/media/madam.c960e62c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/humbleschool/madam.png
// module id = 115
// module chunks = 0